/**
 * /terms — boilerplate Terms of Service. Replace placeholders before
 * paying customers exist (company name, jurisdiction, dispute clause).
 */

import React from 'react';
import PageHeader from '../../components/chrome/PageHeader';
import MarkdownContent from '../../components/chrome/MarkdownContent';
import { usePageMeta } from '../../hooks/usePageMeta';

const Terms: React.FC = () => {
  usePageMeta(
    'Terms of Service — GammaVision',
    'GammaVision terms of service. Acceptable use, payment, cancellation, and limitations of liability.',
  );
  return (
    <>
      <PageHeader title="TERMS OF SERVICE" subtitle="Last updated: 2026-05-01." />
      <MarkdownContent>
        <h2>1. Acceptance</h2>
        <p>By creating a GammaVision account or using the service, you agree to these Terms. If you do not agree, do not use the service.</p>

        <h2>2. The service</h2>
        <p>GammaVision provides analytical visualizations of options dealer flow, including but not limited to gamma exposure (GEX), vanna exposure (VEX), node classification, and air-pocket detection. The service is informational and does not constitute investment, legal, or tax advice.</p>

        <h2>3. Eligibility</h2>
        <p>You must be at least 18 and capable of forming a binding contract in your jurisdiction. By using the service you confirm both.</p>

        <h2>4. Accounts</h2>
        <p>You are responsible for the credentials you create and any activity under them. Notify us immediately of any unauthorized access.</p>

        <h2>5. Payment</h2>
        <p>Paid plans are billed in advance via our payment processor. Trials convert to paid plans on day 10 unless cancelled. Cancellation is effective at the end of the current billing period.</p>

        <h2>6. Refunds</h2>
        <p>If you cancel within 14 days of your first paid charge, we refund in full. Refunds are not available for partial months on subsequent renewals.</p>

        <h2>7. Acceptable use</h2>
        <p>You may not (a) reverse-engineer the service, (b) resell or redistribute data without a written API agreement, (c) use the service to harm others, or (d) attempt to circumvent rate limits or auth.</p>

        <h2>8. Intellectual property</h2>
        <p>The service, including its design, code, and underlying algorithms, is the property of GammaVision. Your data inputs (saved layouts, alert configurations) remain yours.</p>

        <h2>9. Disclaimers</h2>
        <p>The service is provided "as is", without warranty of any kind. Market data is sourced from third parties and may contain errors, omissions, or delays. <strong>Nothing on the service is investment advice.</strong> Verify all numbers against your broker before acting on them.</p>

        <h2>10. Limitation of liability</h2>
        <p>To the maximum extent permitted by law, GammaVision is not liable for any direct, indirect, incidental, consequential, or punitive damages arising from your use of the service. Total liability is capped at the amount you paid us in the prior 12 months.</p>

        <h2>11. Changes</h2>
        <p>We may update these Terms. Material changes will be announced by email at least 14 days before they take effect.</p>

        <h2>12. Governing law</h2>
        <p>These Terms are governed by the laws of the State of Delaware, United States, without regard to its conflict-of-law principles. Any dispute arising out of or relating to these Terms or the service will be resolved in the state or federal courts located in Delaware, and you consent to the personal jurisdiction of those courts.</p>

        <h2>13. Contact</h2>
        <p>Questions? Email <a href="mailto:legal@gammavision.app" style={{ color: 'var(--cyan)' }}>legal@gammavision.app</a>.</p>
      </MarkdownContent>
    </>
  );
};

export default Terms;
